import { render, staticRenderFns } from "./performance-header.component.vue?vue&type=template&id=be8d61fa"
import script from "./performance-header.component.vue?vue&type=script&lang=js"
export * from "./performance-header.component.vue?vue&type=script&lang=js"
import style0 from "./performance-header.component.vue?vue&type=style&index=0&id=be8d61fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports